import { render, staticRenderFns } from "./HorizontalStackedText.vue?vue&type=template&id=0ba7773b&lang=pug"
import script from "./HorizontalStackedText.vue?vue&type=script&lang=ts"
export * from "./HorizontalStackedText.vue?vue&type=script&lang=ts"
import style0 from "./HorizontalStackedText.vue?vue&type=style&index=0&id=0ba7773b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports